import { DatePipe } from '@angular/common';
import { Injector, Pipe, PipeTransform } from '@angular/core';
import { AppComponentBase } from '@shared/app-component-base';
import { AppConsts } from '@shared/AppConsts';
import { Moment } from 'moment';

@Pipe({
  name: 'dateParaguay'
})
export class DateParaguayPipe extends AppComponentBase implements PipeTransform {

  constructor(injector: Injector) {
    super(injector);
  }

  transform(value: Moment, args: any[]): string {
    if (value === undefined || value === null) {
      return '';
    }

    const localization = this.getLocalizationInfo();

    return new DatePipe(localization.name).transform(value, AppConsts.dateTimeFormat);
  }

}
